import { Component, Input, ViewChild } from '@angular/core';
import { FiltersChannel } from '../../../models/filters-channel.model';

@Component({
  standalone: false,
  selector: 'suvo-bi-filters-accordion',
  templateUrl: './filters-accordion.component.html',
  styleUrls: ['./filters-accordion.component.scss'],
})
export class FiltersAccordionComponent {
  @ViewChild('expansionPanel') expansionPanel;

  @Input() filtersChannel: FiltersChannel;
  @Input() autoApplyFilters = false;
  @Input() enableAccordionClose = true;
  @Input() exportDisabled = false;

  expansionOpen = false;
  showContent = false;

  expansionOpened() {
    this.expansionOpen = true;
  }

  expansionClosed() {
    this.expansionOpen = false;
    this.showContent = false;
  }

  expansionFinished() {
    this.showContent = true;
  }

  onFiltersApplied() {
    if (this.enableAccordionClose) {
      this.expansionPanel.close();
    }
  }
}
